/**
 * Created by Oleg on 16.12.19.
 */

const Forces = function () {
    cleverapps.EventEmitter.call(this);

    this.shownForces = [];
    this.locationShownForces = [];

    this.load();

    this.forceView = undefined;
    this.onceForceClosed = undefined;
};

Forces.prototype = Object.create(cleverapps.EventEmitter.prototype);
Forces.prototype.constructor = Forces;

Forces.prototype.isRunningForce = function (force) {
    return this.forceView !== undefined && (force === undefined || this.forceView.force.id === force.id);
};

Forces.prototype.getRunningForce = function () {
    return this.forceView;
};

Forces.prototype.closeRunningForce = function () {
    this.forceView.close();

    if (this.forceView.force.id !== undefined && cleverapps.isNumber(this.forceView.force.id)) {
        this.saveForce(this.forceView.force);
    }

    this.forceView = undefined;

    if (this.onceForceClosed) {
        const onceForceClosed = this.onceForceClosed;
        this.onceForceClosed = undefined;
        onceForceClosed();
    }
};

Forces.prototype.reset = function () {
    this.locationShownForces = [];
    this.shownForces = [];
    this.save();
};

Forces.prototype.load = function () {
    // A force id that no longer fits the sync mask (renumbered, or a dev build that once used a
    // higher one) would fail every save from then on, so it is dropped here rather than kept.
    this.shownForces = (cleverapps.dataLoader.load(DataLoader.TYPES.FORCES) || []).filter((id) => id < cleverapps.SYNCED_BITS);
};

Forces.prototype.loadLocationForces = function (locationId) {
    const locationMeta = cleverapps.meta.getLocationMeta(locationId);

    this.locationConfig = locationMeta.locationConfig;
    this.locationShownForces = this.locationConfig.slot.load("forces") || [];
};

Forces.prototype.save = function (fromServer) {
    cleverapps.dataLoader.save(DataLoader.TYPES.FORCES, this.shownForces);

    if (!fromServer) {
        connector.synchronizer.addSendTask("forces");
    }

    if (this.locationConfig) {
        this.locationConfig.slot.save("forces", this.locationShownForces, fromServer);
    }
};

Forces.prototype.getInfo = function () {
    return {
        forces: cleverapps.toBit(this.shownForces)
    };
};

Forces.prototype.updateInfo = function (data, fromServer) {
    this.shownForces = cleverapps.fromBit(data.forces || 0);

    this.save(fromServer);
};

Forces.prototype.isAvailable = function (element, force) {
    if (!element || (element && element !== ForceView.NO_ELEMENT && !element.isRunning())) {
        return false;
    }

    if (force.id !== undefined) {
        if (this.getStorageForForce(force).indexOf(force.id) !== -1) {
            return false;
        }
    }
    return true;
};

Forces.prototype.isShown = function (force) {
    if (force.id === undefined) {
        return false;
    }

    const storage = this.getStorageForForce(force);
    return storage && storage.indexOf(force.id) >= 0;
};

Forces.prototype.saveForce = function (force) {
    if (force.id && !this.isShown(force)) {
        this.getStorageForForce(force).push(force.id);
        this.save();
    }
};

Forces.prototype.clearForce = function (force) {
    const storage = this.getStorageForForce(force);
    const pos = storage.indexOf(force.id);
    if (pos !== -1) {
        storage.splice(pos, 1);
        this.save();
    }
};

Forces.prototype.getStorageForForce = function (force) {
    return force.saveInLocation ? this.locationShownForces : this.shownForces;
};

Forces.prototype.create = function (element, force, options) {
    if (!element && force.target) {
        element = cleverapps.aims.getTarget(force.target);
    }

    if (!this.isAvailable(element, force)) {
        return;
    }

    this.forceView = new ForceView(element, force, options);

    return this.forceView;
};

// Forces.HALLOWEEN_FORCE = 2;
// Forces.THANKSGIVING_FORCE = 4;
// Forces.CHRISTMAS_FORCE = 5;
// Forces.VALENTINES_FORCE = 6;
// Forces.TOURNAMENT_FORCE = 7;
// Forces.EASTER_FORCE = 8;
// Forces.LEADERS_FORCE = 9;
// Forces.SHOP_HINTS_TAB_FORCE = 11;
// Forces.SHOP_BOOSTERS_TAB_FORCE = 13;
// Forces.ALL_LETTERS_BOOSTER_FORCE = 14;
// Forces.QUEST_ICON = 39;

Forces.PRIZE_CALENDAR = {
    id: 1,
    text: "PrizeCalendar.force"
};

Forces.FREE_UNDO_FORCE = {
    id: 2,
    text: "UndoTutorialMessage"
};

Forces.SEASON_COLLECTIONS_JOKER_TUTORIAL = {
    id: 2,
    finger: true
};

Forces.FREE_HINT_FORCE = {
    id: 3,
    text: "hintTutorialMessage"
};

// The three booster tiers of the aisensia games (cleverapps.Boosters.TYPES.CHEAP / MEDIUM /
// EXPENSIVE), sharing ids with the forces named above and below so a game never has to invent
// one: ids are bits of a 52-bit sync mask and only have to be unique inside a game. A game
// overrides the text: `force: { ...Forces.MEDIUM_BOOSTER_FORCE, text: "MyMagnetTutorial" }`.
Forces.CHEAP_BOOSTER_FORCE = {
    id: 3,
    text: "hintTutorialMessage"
};

Forces.MEDIUM_BOOSTER_FORCE = {
    id: 29,
    text: "magnetTutorialMessage"
};

Forces.EXPENSIVE_BOOSTER_FORCE = {
    id: 9,
    text: "bombTutorialMessage"
};

Forces.FIRST_BOOSTERS_BEFORE = {
    id: 4,
    text: "FirstBoostersBefore.force"
};

Forces.SECOND_BOOSTERS_BEFORE = {
    id: 5,
    text: "SecondBoostersBefore.force"
};

Forces.THIRD_BOOSTERS_BEFORE = {
    id: 6,
    text: "ThirdBoostersBefore.force"
};

Forces.FREE_REPLACE_ALL_FORCE = {
    id: 7,
    text: "ReplaceAllBooster.force"
};

Forces.FREE_PAINT_FORCE = {
    id: 8,
    text: "Paint.force"
};

Forces.FREE_BOMB_FORCE = {
    id: 9,
    text: "outOfBombMovesHint"
};

// Forces.DAILY_TASKS_FORCE = 10;

Forces.COOLDOWN_FORCE = {
    id: 11,
    text: "CoolDownNode.force",
    finger: false
};

Forces.MINIGAME_FORCE = {
    id: 12,
    text: "Forces.MiniGame"
};

Forces.FOG_EXPLORE = {
    id: 13
};

Forces.TROOP_CARDS_FORCE = {
    id: 14,
    text: "TroopCards.force"
};

Forces.FRIEND_BALLOON = {
    id: 14,
    text: "FriendBalloonTutorial.step1",
    finger: true,
    shadow: false
};

Forces.FRIEND_BALLOON_RECEIVE_GIFT = {
    finger: true
};

Forces.FRIEND_BALLOON_SEND_GIFT = {
    text: "FriendBalloonTutorial.step2",
    finger: true,
    shadow: false
};

Forces.MENU_BAR_SOFT_FORCE = {
    id: 15,
    text: "SoftForce",
    finger: {
        useForceTarget: true
    },
    available: cleverapps.config.availables.MENU_BAR_SOFT_FORCE,
    productKey: "softCurrencyVerySmall",
    productOptions: {
        price: 0
    }
};

Forces.FREE_NEXT_PIECES_FORCE = {
    id: 16,
    text: "ClearPiecesBooster.force"
};

Forces.MERGE2_GENERATOR_O = {
    id: 16,
    text: "SideQuestTutorialO.text1"
};

Forces.HEROES_AVAILABLE = {
    id: 17,
    text: "Forces.HeroesAvailable"
};

Forces.MERGE2_CUP_TUTORIAL = {
    id: 17
};

Forces.META_TUTORIAL = {
    id: 17,
    text: "MetaTutorialMessage2",
    closeByTouchInShadow: {
        delay: 3000
    }
};

Forces.DAILY_CUP = {
    id: 18,
    text: "Cups.daily.force"
};

Forces.FREE_UNDO_PIECE = {
    id: 19,
    text: "UndoPieceBooster.force"
};

// Forces.LANTERN = 20;

Forces.TRADE_WINDOW_FORCE = {
    id: 21,
    text: "TradeWindow.force",
    target: "unittradeicon",
    controls: ["UnitTradeIcon"]
};

Forces.TRADE_SELECT_SOURCE = {
    text: "Forces.TradeSelectLeft"
};

Forces.TRADE_SELECT_TARGET = {
    text: "Forces.TradeSelectRight"
};

Forces.FREE_VACUUM_FORCE = {
    id: 22,
    text: "VacuumBooster.force"
};

Forces.METHA_PLAY_BUTTON = {
    id: 23,
    controls: ["play_button"],
    text: function () {
        return Messages.get(Messages.has("SimpleMethaPlayButton.force") ? "SimpleMethaPlayButton.force" : "MethaPlayButton.force");
    }
};

Forces.KNOCKOUT_PLAYERS = {
    id: 24,
    text: "KnockoutPlayers.force",
    button: {
        text: "SkipButton"
    },
    finger: false,
    closeByTouchInShadow: true
};

Forces.KEYPAD = {
    id: 25,
    text: "Keypad.force"
};

Forces.SEASON_PASS = {
    id: 25,
    text: "SeasonPass.Tutorial.Force1",
    person: "hero",
    position: () => MinimalDialogue.POSITIONS.CENTER
};

Forces.ROYAL_LEAGUE = {
    id: 25,
    text: "RoyalLeague.Force.Help"
};

Forces.LIGHTNING_RUSH = {
    id: 26,
    text: "LightningRush.Force",
    shadow: false,
    finger: false,
    pointer: true
};

Forces.PINBALL = {
    id: 26,
    text: "Pinball.Force"
};

Forces.COOKIEJAR = {
    id: 27,
    text: function () {
        return Messages.get("Cookiejar.force", {
            cookiesToReward: cleverapps.CookieJar.calcCookiesToReward()
        });
    },

    button: {
        text: "OK"
    },
    closeByTouchInShadow: true
};

Forces.GENERATOR_MULTIPLIER = {
    id: 27,
    text: function () {
        return Messages.get("GeneratorMultiplierTutorial.step1");
    }
};

Forces.TREASURE_SEARCH = {
    id: 28,
    text: "TreasureSearchTutorial.Force0"
};

Forces.NEW_UNIT = {
    id: 29,
    text: "Merge2.NewUnitTutorial1"
};

Forces.FREE_SHUFFLE_FORCE = {
    id: 29,
    text: "ShuffleBooster.force"
};

Forces.BACKPACK = {
    id: 30,
    text: "Merge2.BackpackTutorial1"
};

Forces.MERGE2_UNDO_HINT = {
    id: 20,
    text: "Merge2.UndoTutorial1"
};

Forces.PHOTO_CLOVER = {
    id: 30,
    text: "PhotoClover.force"
};

Forces.TRICKY_LEVEL = {
    id: 31,
    text: "TrickyLevelForce"
};

Forces.SPECIAL_ENERGY_OFFER = {
    id: 31,
    finger: true,
    text: "SpecialEnergyOffer"
};

Forces.SIMPLE = {
    id: 32
};

Forces.BONUS_WORLD = {
    id: 33
};

Forces.HUNGRY_GAMES = {
    id: 33,
    text: "HungryGames.Force.Players",
    finger: false,
    closeByTouchInShadow: true
};

Forces.SLOT_MACHINE_ICON = {
    id: 34,
    text: "SlotMachine.IconForce"
};

Forces.MERGE2_MISSION = {
    id: 34,
    text: "Merge2MissionTutorial.items",
    okButton: true
};

Forces.SLOT_MACHINE = {
    id: 35,
    text: "SlotMachine.Force"
};

// deprecated
Forces.ADVENTURE2_SPAWNER = {
    id: 35
};

Forces.BUY_ENERGY_ICON = {
    id: 36,
    text: "BuyEnergy.IconForce",
    productKey: cleverapps.config.type === "merge2" ? "buyEnergy20" : "buyEnergy350",
    productOptions: cleverapps.config.type === "merge2"
        ? { price: 0, reward: 100 }
        : { price: 0, reward: 30, timeout: 0 }
};

Forces.UNITS_SHOP_ICON = {
    id: 37,
    text: "UnitsShop.IconForce"
};

Forces.SLOT_MACHINE_HELP = {
    id: 38,
    text: "SlotMachine.HelpForce"
};

// deprecated
Forces.ADVENTURE3_SPAWNER = {
    id: 38
};

Forces.FREE_OPEN_LETTER_FORCE = {
    id: 39,
    text: "OpenLetter.force"
};

Forces.GENERATOR_SPEED_UP = {
    id: 39,
    text: "GeneratorSpeedUp.Force"
};

Forces.TRAVEL_BOOK = {
    id: 40,
    person: "king"
};

Forces.TRAVEL_BOOK_HINT = {
    person: "king"
};

Forces.PINBALL_ICON = {
    id: 41,
    text: "Pinball.IconForce"
};

// deprecated
Forces.ADVENTURE4_SPAWNER = {
    id: 41
};

Forces.CLANS_ICON = {
    id: 42,
    text: "Clans.force"
};

Forces.OFFER_ICON_SLOT1 = {
    id: 43,
    text: "Offer.IconForce"
};

Forces.OFFER_ICON_SLOT2 = {
    id: 44,
    text: "Offer.IconForce"
};

// Forces.LEVELPASS = 45;

// deprecated
Forces.ADVENTURENY_SPAWNER = {
    id: 45
};

Forces.SECOND_LANDMARK = {
    id: 46
};

Forces.WEEKLY_TOURNAMENT = {
    id: 46,
    text: "WeeklyTournament.IconForce"
};

Forces.CONTINUE_ORDERS = {
    id: 46,
    shadow: false,
    disableFallbackTimeout: true
};

Forces.LANDMARK_DONOR_SLOT1 = {
    id: 47,
    text: "Landmarks.force"
};

Forces.RAVE_RAVIEWS = {
    id: 47,
    text: "RaveReviews.force",
    disableFallbackTimeout: true,
    position: () => MinimalDialogue.POSITIONS.CENTER,
    okButton: true
};

Forces.LANDMARK_DONOR_SLOT2 = {
    id: 48,
    text: "Landmarks.force"
};

Forces.RAVE_RAVIEWS_REWARD = {
    id: 48,
    text: "RaveReviewsReward.force",
    disableFallbackTimeout: true,
    position: () => MinimalDialogue.POSITIONS.CENTER
};

Forces.STICKERS_BOOK_FORCE = {
    id: 49,
    text: "StickersBook.force"
};

Forces.STICKERS_BOOK2_FORCE = {
    id: 52,
    text: "StickersBook.force"
};

Forces.FREE_UNLIMITED_LIVES_FORCE = {
    id: 50,
    text: "FreeUnlimitedLivesWindow.force"
};

// deprecated
Forces.OFFER_ICON_SLOT1_EXP = {
    id: 50
};

Forces.FREE_PROLONGATION_FORCE = {
    id: 51,
    text: "Prolongation.force"
};

Forces.STORAGE_FORCE = {
    target: "warehouse",
    controls: ["WarehouseIcon"]
};

Forces.FREE_EXTRA_SLOT_FORCE = {
    id: 51,
    finger: {
        useForceTarget: true
    },
    person: "fairy_dwarf_violet",
    text: "ExtraSlotTutorial.force"
};

// MAXIMUM FORCE NEED TO BE LESS THAN 52 FOR NOW

Forces.LOCATION_OFFER_ICON_CHEAP = {
    id: 1,
    saveInLocation: true,
    text: "Offer.IconForceCheap"
};

Forces.LOCATION_OFFER_ICON_EXP = {
    id: 2,
    saveInLocation: true,
    text: "Offer.IconForceExp"
};

Forces.ADVENTURE_SPAWNER = {
    id: 3,
    saveInLocation: true,
    text: "Adventure2Spawner.step1",
    finger: false,
    closeByTouchInShadow: true
};